import { ISystemActiveIngredient } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetActiveIngredientsQuery<D extends ISystemActiveIngredient[]>(
  params?: HydraQueryParams<D>
) {
  const { vars, options } = params || {};
  return useHydraQuery<D>('getActiveIngredients', '/api/active_ingredients', {
    vars,
    options,
  });
}
